import { Component, OnInit, Inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceService } from 'src/app/shared/services/invoice.service';
import { KlyantService } from 'src/app/shared/services/klyant.service';

@Component({
  selector: 'app-select-pre-invoice-fee-supplier',
  templateUrl: './select-pre-invoice-fee-supplier.component.html',
  styleUrls: ['./select-pre-invoice-fee-supplier.component.scss']
})
export class SelectPreInvoiceFeeSupplierComponent implements OnInit {

  @Input() preInvoiceFeeId: number;

  supplierList: any = [];
  supplierId: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private klyantService: KlyantService,
    private invoiceService: InvoiceService) { 
  }

  ngOnInit(): void {
    this.klyantService.getSuppliers().subscribe((results) => {
      this.supplierList = results;
    });
  }


  setSupplier() {
    if (this.supplierId) {
      this.invoiceService.setSupplierOnPreInvoiceFee(this.preInvoiceFeeId, this.supplierId).subscribe((result) => {
        this.activeModal.close(true);
      });
    }
  }
}
